import { EntityLegalTypeEnum } from "gen/model/entityLegalTypeEnum";
import { InvestmentOrPortfolioEnum } from "gen/model/investmentOrPortfolioEnum";
import * as yup from "yup";

export const investmentCreateSchema = yup
  .object()
  .shape({
    legal_name: yup.string().max(256).required(),
    external_id: yup.string().max(256).required(),
    legal_type: yup
      .string()
      .oneOf(Object.values(EntityLegalTypeEnum))
      .required(),
    metadata: yup.object().shape({
      investment_or_portfolio: yup
        .string()
        .oneOf(Object.values(InvestmentOrPortfolioEnum))
        .required(),
      is_allocable: yup.boolean().required(),
      investment_type: yup.string().required(),
    }),
  })
  .required();
